"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCachedFilters = exports.CachedFiltersProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var Context = (0, react_1.createContext)({
    getFilters: function () { return undefined; },
    setFilters: function () { },
});
var CachedFiltersProvider = function (_a) {
    var children = _a.children;
    var Provider = Context.Provider;
    var _b = (0, react_1.useState)(new Map()), filters = _b[0], setFiltersState = _b[1];
    var getFilters = (0, react_1.useCallback)(function (key) {
        return filters.get(key);
    }, [filters]);
    var setFilters = (0, react_1.useCallback)(function (key, filters) {
        setFiltersState(function (prev) {
            var previousFilters = prev.get(key) || {};
            var newFilters = __assign(__assign({}, previousFilters), filters);
            return new Map(prev.set(key, newFilters));
        });
    }, []);
    return (0, jsx_runtime_1.jsx)(Provider, { value: { getFilters: getFilters, setFilters: setFilters }, children: children });
};
exports.CachedFiltersProvider = CachedFiltersProvider;
var useCachedFilters = function (_a) {
    var key = _a.key, initialValues = _a.initialValues, skip = _a.skip;
    var _b = react_1.default.useContext(Context), getFilters = _b.getFilters, setFiltersFromContext = _b.setFilters;
    var filtersFromContext = getFilters(key);
    var setFilters = (0, react_1.useCallback)(function (filters) {
        setFiltersFromContext(key, filters);
    }, [key, setFiltersFromContext]);
    if (!filtersFromContext && initialValues && !skip) {
        setFilters(initialValues);
    }
    var filters = skip
        ? filtersFromContext
        : filtersFromContext || initialValues;
    return { filters: filters, setFilters: setFilters };
};
exports.useCachedFilters = useCachedFilters;
